var React = require('react');

function SlashesRightInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M194 95L138.84 0H111L166.16 95H194Z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M250 95L194.84 0H167L222.16 95H250Z","key":1}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M83 95L27.8404 0H0L55.1596 95H83Z","key":2}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M139 95L83.8404 0H56L111.16 95H139Z","key":3}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M222 0H249.766L263 22.9176V71L222 0Z","key":4})]);
}

SlashesRightInline.defaultProps = {"width":"263","height":"95","viewBox":"0 0 263 95","fill":"none"};

module.exports = SlashesRightInline;

SlashesRightInline.default = SlashesRightInline;
